module.exports = __webpack_public_path__ + "img/format_extension_png_page_file_icon_124654.755cb676.png";